import React from 'react';
import {
  LoadingTaskFileIcon,
  RemoveTaskFileIcon,
  TaskFileName,
  TaskFilePickerChip,
  TaskFileType,
} from './styles';
import Icon from 'components/Icon';
import { LoadingIcon } from 'components/LoadingIcon/LoadingIcon';
import { ClassDocument } from 'store/companies/companiesTypes';
import { getProviderIcon } from 'store/providers/providerTypes';
import { VideoMeetingConst } from '../ClassFilePicker';

interface IComponentProps {
  large?: boolean;
  isLoading?: boolean;
  item: ClassDocument;
  onRemove?: (item: ClassDocument) => void;
  onOpen: (
    item: ClassDocument
  ) => (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

const ClassDocumentItem: React.FC<IComponentProps> = ({
  isLoading,
  item,
  onOpen,
  onRemove,
  large,
}) => {
  return (
    <TaskFilePickerChip onClick={onOpen(item)} large={large}>
      <TaskFileName>
        <TaskFileType>
          <Icon
            type={
              item.content === VideoMeetingConst
                ? 'video'
                : getProviderIcon[item.type || 'quill']
            }
          />
        </TaskFileType>
        <span>{item.title}</span>
      </TaskFileName>
      {isLoading ? (
        <LoadingTaskFileIcon>
          <LoadingIcon color="gray" />
        </LoadingTaskFileIcon>
      ) : onRemove ? (
        <RemoveTaskFileIcon>
          <Icon
            type="x"
            onClick={(e) => {
              e.stopPropagation();
              onRemove!(item);
            }}
          />
        </RemoveTaskFileIcon>
      ) : undefined}
    </TaskFilePickerChip>
  );
};

export default ClassDocumentItem;
